import { GeometryFeatureBase } from './geometry-feature.base';
import { MapObject } from '../map-object';

/** One Web-Mercator cell displayed by a Grid feature. */
export interface GridMapObject extends MapObject<string> {
  readonly zoom: number;
  readonly tileX: number;
  readonly tileY: number;
}

/** Base lifecycle for Web-Mercator grid features. */
export abstract class GridFeatureBase<TObject extends GridMapObject>
extends GeometryFeatureBase<TObject> {
  readonly geometryType = 'grid' as const;
}
